export var UsingRegexp = /^([A-Za-z0-9_-]+),([A-Za-z0-9_-]+)$/;
export var ManyToManyFieldPrefix = '@@ra-many-to-many/';
